import * as T from 'three';
import { toonMaterial } from './art-direction.js';

const sphere=new T.IcosahedronGeometry(1,1),cone=new T.ConeGeometry(1,1,6),cylinder=new T.CylinderGeometry(1,1,1,12),torus=new T.TorusGeometry(1,.16,5,18);
const shape=new T.Shape();for(let i=0;i<10;i++){const a=i*Math.PI/5,r=i%2?.45:1;i?shape.lineTo(Math.sin(a)*r,Math.cos(a)*r):shape.moveTo(Math.sin(a)*r,Math.cos(a)*r);}shape.closePath();
const starGeometry=new T.ExtrudeGeometry(shape,{depth:.16,bevelEnabled:false});
function part(group,geo,color,x,y,z,sx,sy,sz,glow=0){const m=new T.Mesh(geo,toonMaterial(color,.15,glow));m.position.set(x,y,z);m.scale.set(sx,sy,sz);group.add(m);return m;}

/** Shared geometry and materials: distinct silhouettes without per-projectile allocations. */
export function createProjectile(kind,color){
  const g=new T.Group();g.name=`Projectile / ${kind}`;
  if(kind==='cookie'){
    const disc=part(g,cylinder,'#b46e35',0,0,0,.26,.09,.26);disc.rotation.x=Math.PI/2;
    part(g,torus,'#f7d894',0,0,.06,.21,.21,.21);
    for(let i=0;i<4;i++){const a=i*2.4;part(g,sphere,'#623b2b',Math.cos(a)*.12,Math.sin(a)*.12,.065,.043,.043,.032);}
  }else if(kind==='ice'||kind==='dagger'||kind==='musket'){
    const c=kind==='dagger'?'#91efb0':kind==='musket'?'#ffc96f':'#8de5ff';
    const tip=part(g,cone,c,0,0,.25,.14,.72,.14,.55);tip.rotation.x=Math.PI/2;
    part(g,sphere,color,0,0,-.14,.13,.13,.35);
  }else if(kind==='star'){
    part(g,starGeometry,'#ffca6c',0,0,0,.27,.27,.27,.48);
    part(g,sphere,'#fff2ba',0,0,.07,.08,.08,.035,.65);
  }else if(kind==='electric'){
    const bolt=part(g,cone,'#a679ed',0,0,0,.22,.65,.22,.38);bolt.rotation.x=Math.PI/2;
    part(g,sphere,'#bdefff',0,0,.15,.055,.055,.28,.9);
  }else if(kind==='wave'){
    const crest=part(g,torus,'#65dbe9',0,0,0,1.05,.54,.35,.55);crest.rotation.x=-.3;
    part(g,sphere,'#386daf',0,-.12,0,1.06,.24,.3);
  }else if(kind==='ornament'){
    part(g,sphere,color,0,0,0,.23,.23,.23,.18);
    part(g,torus,'#ffc778',0,0,0,.22,.22,.22,.35);
  }else if(kind==='ember'){
    const flame=part(g,cone,'#f4783d',0,0,-.1,.16,.5,.16,.45);flame.rotation.x=-Math.PI/2;
    part(g,sphere,'#ffc875',0,0,.10,.10,.10,.10,.7);
  }else if(kind==='crumb'){
    part(g,sphere,'#d6934f',0,0,0,.16,.13,.22);
    part(g,sphere,'#f2cf8d',0,.03,.04,.07,.05,.09,.4);
  }else{
    part(g,sphere,'#8fcfe5',0,0,0,.22,.22,.24);
    part(g,sphere,'#e0f6ff',-.05,.05,.08,.13,.13,.15,.18);
  }
  return g;
}
export function animateProjectile(g,b,time){
  g.rotation.set(0,Math.atan2(b.vx,b.vz),0);
  if(b.kind==='cookie'||b.kind==='star'||b.kind==='ornament')g.children[0].rotation.z=time*9;
}
